const mediaQueryLg = window.matchMedia("(max-width: 992px)").matches;

const header = document.getElementById("gpc-header");
const nav = document.querySelector(".site-navigation");
const mobileToggle = document.querySelector(".mobile-nav-btn");
const languageSwitcher = document.querySelector(".language-switcher");
const themeSwitcher = document.querySelector(".theme-switcher");
let lastScrollTop = 0;

if (header) {
	window.addEventListener("scroll", fixedHeader);
	// Move Toggler to bottom of navigation DIV
	// if (mediaQueryLg) {
	// 	nav.appendChild(languageSwitcher);
	// }

	// Open Mobile Menu
	mobileToggle.addEventListener("click", toggleNav);
}

if (themeSwitcher) {
	themeSwitcher.addEventListener("click", switchTheme);
}

function fixedHeader() {
	let currentScrollTop = window.scrollY;
	// console.log(`window: ${currentScrollTop}; header: ${header.offsetHeight}`);

	if (lastScrollTop - currentScrollTop < 0) {
		// Scoll Down

		header.classList.remove("c-fixed");
		if (window.scrollY < header.offsetHeight) {
			header.classList.remove("animate-in");
		} else {
			header.classList.add("animate-in");
		}
	} else if (lastScrollTop - currentScrollTop > 0) {
		// Scoll Up
		header.classList.remove("animate-in");
		if (window.scrollY < header.offsetHeight) {
			header.classList.remove("c-fixed");
			// header.classList.add("animate-in");
		} else {
			header.classList.add("c-fixed");
			// header.classList.remove("animate-in");
		}
	}

	// if (window.scrollY < header.offsetHeight + 40) {
	// 	header.classList.remove("c-fixed");
	// 	header.classList.remove("animate-in");
	// } else if (lastScrollTop - currentScrollTop < 0) {
	// 	// console.log("Down");
	// 	header.classList.remove("c-fixed");

	// 	if (window.scrollY < header.offsetHeight + 40) {
	// 		header.classList.remove("animate-in");
	// 	} else {
	// 		header.classList.add("animate-in");
	// 	}
	// 	header.classList.add("animate-in");
	// } else if (lastScrollTop - currentScrollTop > 0) {
	// 	// console.log("Up");
	// 	header.classList.add("c-fixed");
	// 	if (window.scrollY < header.offsetHeight + 40) {
	// 		header.classList.remove("c-fixed");
	// 		// header.classList.add("animate-in");
	// 	} else {
	// 		header.classList.add("c-fixed");
	// 		// header.classList.remove("animate-in");
	// 	}
	// }

	lastScrollTop = currentScrollTop;
}

function toggleNav(e) {
	e.preventDefault();
	header.classList.toggle("mobile-fixed");
	if (header.classList.contains("mobile-fixed")) {
		document.body.style.height = "100vh";
		document.body.style.overflow = "hidden";
		mobileToggle.setAttribute("aria-expanded", true);
	} else {
		document.body.style.height = "auto";
		document.body.style.overflow = "auto";
		mobileToggle.setAttribute("aria-expanded", false);
	}
}

function switchTheme(e) {
	e.preventDefault();
	document.documentElement.classList.toggle("theme-dark");
	if (document.documentElement.classList.contains("theme-dark")) {
		localStorage.setItem("gpcSIteTheme", "theme-dark");
		themeSwitcher.innerHTML = `<i class="fa-regular fa-sun" aria-hidden="true"></i>`;
	} else {
		localStorage.removeItem("gpcSIteTheme");
		themeSwitcher.innerHTML = `<i
					class="fa-solid fa-moon" aria-hidden="true"></i>`;
	}
}

let getSiteTheme = localStorage.getItem("gpcSIteTheme") || "";
function setTheme() {
	if (getSiteTheme && getSiteTheme === "theme-dark") {
		document.documentElement.classList.add("theme-dark");
		themeSwitcher.innerHTML = `<i class="fa-regular fa-sun" aria-hidden="true"></i>`;
	} else {
		document.documentElement.classList.remove("theme-dark");
		themeSwitcher.innerHTML = `<i
		class="fa-solid fa-moon" aria-hidden="true"></i>`;
	}
}

if (themeSwitcher) {
	setTheme();
}
